export default "__VITE_ASSET__Be1O$JNr__"